module.exports = __webpack_public_path__ + "static/media/galeriemirage-interior-1024x682.79aa6fa2.jpg";